import axios from 'axios';
import { DtoExtension } from '@/shared/constants/dto';
import { getMimeTypeFromExtension } from '@/shared/utils/get-mime-type-from-extension';

/**
 * publicUrl 필드를 가진 아이템에서 파일을 다운로드하여 Blob으로 반환
 * UserFolderItemContent, ProjectContentV2 모두 지원
 *
 * S3 가 객체 Content-Type 을 `application/x-www-form-urlencoded` 같이
 * 잘못 내려주는 경우 권위적 소스인 `extension` 으로 blob 의 mimeType 을 보정한다.
 * `FileExtensionValue` 는 `DtoExtension` 의 부분집합이므로 그대로 전달 가능하다.
 */
export async function fetchAssetBlob(
  item: { publicUrl?: string; extension?: DtoExtension | null },
  onProgress: (progress: number) => void = () => {},
): Promise<Blob> {
  if (!item.publicUrl) {
    throw new Error('publicUrl이 없습니다.');
  }

  const response = await axios.get<Blob>(item.publicUrl, {
    responseType: 'blob',
    onDownloadProgress: (progressEvent) => {
      if (!progressEvent.total) return;

      const progress = Math.round(
        (progressEvent.loaded / progressEvent.total) * 100,
      );
      onProgress(progress);
    },
  });

  const blob = response.data;
  const expectedMimeType = getMimeTypeFromExtension(item.extension);
  if (expectedMimeType && blob.type !== expectedMimeType) {
    return new Blob([blob], { type: expectedMimeType });
  }
  return blob;
}
